import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import editPencil from "../../assets/images/edit-icon.png";
import { connect } from "react-redux";
import { ALT_THUMBNAIL, API_LIMIT, MODULE_ID_MAP, START_PAGE, contentMaster, isModuleExist } from "../../utils/Constant";
import { deleteCategoryApi, deleteDimensionsApi, getAllCategoryApi, getAllContentDimensionsApi } from "./Api";
import CategoryMasterForm from "./CategoryMasterForm";
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { CATEGORY_VERIFY, DIMENSION_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import  TemplateDimensionsForm from "./TemplateDimensionsForm";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";

export class TemplateDimensionsTab extends Component {
  constructor(props) {

    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterTemplateDimension);
    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      dimensionOption: [],
      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }
  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllContentDimensionsApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";

    if (prevPage !== page || prevVerified !== verified) {

      this.setState({ currentPage: page }, () => {
        this.props.getAllContentDimensionsApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {
    deleteDimensionsApi(id, this, this.openCloseDeleteModal)
  }
  render() {
    const { showEdit, access } = this.state;
    const { contentDimensionsList, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.dimensionName}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}

          />
        )}
        {
          showEdit &&
          <TemplateDimensionsForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state?.editData}
            this={this}
          />
        }
        <VerifiedModal
          name={`'${this.state.editData?.dimensionName}'`}
          show={this.state.show}
          url={DIMENSION_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllContentDimensionsApi(this); }}
        />
        <ComponentHeader
          title="Template Dimensions"
          isSearch={false}
          placeholder={"Search "}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          primaryBtn={access.createAccess ? "Add Dimensions" : ""}
          handlePrimaryBtn={() => {
            this.setState({ showEdit: true })
          }}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">

          <CustomTable
            data={contentDimensionsList?.list || []}
            columns={[
              {
                width: 250,
                title: "Name",
                dataIndex: "dimensionName",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "dimensionName") {
                    return rowData.dimensionName;
                  }
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 250,
                title: "Description",
                dataIndex: "description",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "description") {
                    return rowData.description;
                  }
                },
              },



              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "updatedBy") {
                    return rowData.updatedBy?.name || "Na";
                  }
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "createdBy") {
                    return rowData.createdBy?.name || "Na";
                  }
                },
              },
              {
                width: 200,
                title: "Action",
                dataIndex: "",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "") {
                    return (
                      <>
                        {access.updateAccess && <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />}
                        {access.deleteAccess && <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />}


                      </>
                    );
                  }
                },
              },
            ]}
            message="No data found" // For Pagination
            history={this.props.history}
            location={this.props.location}
            total={totalPages}
            currentPage={currentPage}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllContentDimensionsApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateDimensionsTab));